import React from "react";
import OrderService from "../../services/order.service";
import { getSubsite } from '../../reducers/auth';
import { useSelector } from 'react-redux';

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const AdminHome = () => {
  const [openOrders, setOpenOrders] = React.useState(null);
  const currentSubsite = useSelector(getSubsite);

  React.useEffect(() => {
    const loadOrders = async () => {
      try {
        const orders = await OrderService.getOpenOrders();
        setOpenOrders(orders);
      } catch (error) {
        console.error('Error loading open orders:', error);
        setOpenOrders([]);
      }
    };

    loadOrders();
  }, []);

  return (
    <>
        <div style={{ backgroundColor: 'black', display: 'inline-block', padding: '10px', width:"100%", marginTop: 8 }}>
        <img height="75" src={`${BACKEND_URL}/uploads/subsites/${currentSubsite.logoFilename}`} /><br/>
        </div>
        <div className="stats">
            <div className="stat-item">
                <h3>Open Orders</h3>
                <div className="stat-value">
                    {openOrders?.length || 0}
                </div>
            </div>
        </div>
        {openOrders && openOrders.length > 0 && (
          <div>
            {openOrders.sort((a,b) => new Date(a.placed) - new Date(b.placed))[0].placed && 
              (() => {
                const oldestOrder = new Date(openOrders[0].placed);
                const daysSinceOrder = Math.floor((new Date() - oldestOrder) / (1000 * 60 * 60 * 24));
                return daysSinceOrder > 14 ? (
                  <div className="alert alert-danger">
                    Oldest open order is {daysSinceOrder} days old (from {oldestOrder.toLocaleDateString()})
                  </div>
                ) : null;
              })()
            }
          </div>
        )}
    </>  );
};
export default AdminHome;

